const dropdown = document.getElementsByClassName('dropdown');

for (var i = 0; i < dropdown.length; i++) {
    dropdown[i].addEventListener('click', toggleDropdown)
}

function toggleDropdown(event) {
    event.target.parentElement.classList.toggle('active')
}